package one.healthium.logger

@JsModule("@sentry/browser")
@JsNonModule
@JsName("Sentry")
external object SentryJs {

    fun init(options: dynamic)

    fun captureMessage(message: String): dynamic

    fun captureMessage(message: String, captureContext: (Scope: dynamic) -> Unit): dynamic

    fun captureException(exception: Any): dynamic

    fun captureException(exception: Any, captureContext: (Scope: dynamic) -> Unit): dynamic

    fun configureScope(callback: (Scope: dynamic) -> Unit)

    fun close()
}

fun initJs(configuration: (SentryOptions) -> Unit) {
    val options = SentryOptions()
    configuration.invoke(options)
    val jsOptions: dynamic = js("{}")
    jsOptions.dsn = options.dsn
    jsOptions.debug = options.debug
    jsOptions.sendDefaultPii = options.sendDefaultPii
    jsOptions.environment = options.environment
    jsOptions.attachStacktrace = options.attachStackTrace
    jsOptions.tracesSampleRate = options.tracesSampleRate
    SentryJs.init(jsOptions)
}

class SentryOptions {
    var dsn: String = ""
    var debug: Boolean = false
    var sendDefaultPii: Boolean = false
    var environment: String = "production"
    var attachStackTrace: Boolean = true
    var tracesSampleRate: Double = 0.0
}
